import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { MCardBodyContainerComponent } from './card-body-container.component';
@NgModule({
  declarations: [MCardBodyContainerComponent],
  exports: [MCardBodyContainerComponent],
  imports: [CommonModule, NzTabsModule, FormsModule, NzIconModule, NzToolTipModule]
})
export class MCardBodyContainerModule {}
